import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import resourcesActions from '@/redux/resources/actions';
import modalsActions from '@/redux/modals/actions';
import { Loader } from '@/components';
import { dateToString } from '@/utils/common';

const AsyncResources = Loadable({
  loader: () => import('./Resources'),
  loading: Loader,
});

const mapStateToProps = ({ resources, modals }) => ({
  ...resources,
  isUploadResourceModalOpen: modals.isUploadResourceModalOpen,
  tableData: resources.data.map((resource) => {
    return Object.assign(
      {},
      {
        key: resource.id,
        id: resource.id,
        name: resource.name,
        file: resource.file,
        fileFormat: resource.file.substr(resource.file.lastIndexOf('.') + 1),
        uploaded: dateToString(resource.created),
      }
    );
  }),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchResources: resourcesActions.fetchResources,
      uploadResource: resourcesActions.uploadResource,
      deleteResource: resourcesActions.deleteResource,
      toggleUploadResourceModal: modalsActions.toggleUploadResourceModal,
      onRemoveFile: resourcesActions.onRemoveFile,
      beforeUpload: resourcesActions.beforeUpload,
      setFileName: resourcesActions.setFileName,
      tableChange: resourcesActions.tableChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncResources);
